import { render, staticRenderFns } from "./consult-info.vue?vue&type=template&id=3fa00861&"
import script from "./consult-info.vue?vue&type=script&lang=js&"
export * from "./consult-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports